module.exports = __webpack_public_path__ + "static/media/boden.5b1e81f7.svg";